module.exports = new __parcel__URL__("clipboard.b51b96c4.png").toString();